<template>
  <o-tabs :items="tabItems">
    <template #[TABS.GENERAL.name]>
      <edit-live-informations-form
        :live="live"
        class="box"
        @update:live="$emit('update:live', $event)"
      />
      <edit-live-roles-form class="box" :live="live" />
      <b-field label="Code d'intégration du live" class="box">
        <b-field>
          <b-input :value="iframe" expanded readonly />
          <p class="control">
            <copy-button :textToCopy="iframe" />
          </p>
        </b-field>
      </b-field>
    </template>
    <template #[TABS.STATISTICS.name]>
      <edit-live-stat-tab :live="live" class="box" />
    </template>
    <template #[TABS.EXTERNAL_LINKS.name]>
      <edit-live-external-link-tab :live="live" class="box" />
    </template>
    <template #[TABS.SPONSORS.name]>
      <image-upload-form
        :imageType="imageType"
        :imageUrl="live.sponsorUrl"
        :submit="uploadOrganizerImage"
        label="Image organisateur"
        class="box column is-6 ml-0"
      />
      <edit-live-sponsor-tab :live="live" class="box column is-12" />
    </template>
    <template #[TABS.DOCUMENTS.name]>
      <edit-live-document-tab :live="live" class="box" />
    </template>
    <template #[TABS.REVIEW.name]>
      <edit-live-review-tab :live="live" class="box" />
    </template>
  </o-tabs>
</template>

<script>
import { mapActions } from 'vuex'
import OTabs from '@components/Tabs.vue'
import CopyButton from '@components/CopyButton.vue'
import ImageUploadForm from '@components/ImageUploadForm.vue'
import EditLiveStatTab from './EditLiveStatTab'
import EditLiveReviewTab from './EditLiveReviewTab'
import EditLiveDocumentTab from './EditLiveDocumentTab.vue'
import EditLiveSponsorTab from './EditLiveSponsorTab'
import EditLiveExternalLinkTab from './EditLiveExternalLinkTab'
import EditLiveInformationsForm from './EditLiveInformationsForm.vue'
import EditLiveRolesForm from './EditLiveRolesForm'

export default {
  name: 'EditInformationsLiveTab',

  components: {
    OTabs,
    CopyButton,
    ImageUploadForm,
    EditLiveStatTab,
    EditLiveReviewTab,
    EditLiveSponsorTab,
    EditLiveDocumentTab,
    EditLiveExternalLinkTab,
    EditLiveInformationsForm,
    EditLiveRolesForm,
  },

  props: {
    live: {
      type: Object,
      required: true,
    },
  },

  created() {
    this.imageType = 'image/jpeg, image/png'
    this.TABS = {
      GENERAL: { label: 'Général', name: 'general' },
      STATISTICS: { label: 'Statistiques', name: 'statistics' },
      EXTERNAL_LINKS: { label: 'Liens externes', name: 'external-links' },
      SPONSORS: { label: 'Sponsors', name: 'sponsors' },
      DOCUMENTS: { label: 'Documents', name: 'documents' },
      REVIEW: { label: 'Bilan', name: 'review' },
    }
    this.tabItems = Object.values(this.TABS)
  },

  computed: {
    iframe() {
      return `<iframe src="https://owaka.live/${this.live.slug}" width="100%" height="600"></iframe>`
    },
  },

  methods: {
    ...mapActions('ui', ['addToastMessage']),

    async uploadOrganizerImage(image) {
      try {
        const live = await this.$services.liveService.addLiveSponsor(this.live.id, image)
        this.$emit('update:live', live)

        this.addToastMessage({
          text: "L'image de l'organisateur a été mise à jour.",
          type: 'is-success',
        })
      } catch (err) {
        this.addToastMessage({
          text: 'Une erreur interne est survenue.',
          type: 'is-danger',
        })
      }
    },
  },
}
</script>
